import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconActivity, IconHome, IconSettings } from '@tabler/icons-react';
import { lazy } from 'react';

/**
 * Бутстрап платформенного модуля Core (клиентская часть).
 */
export async function setup(app: AppRuntime): Promise<void> {
  // «Главная» — первый пункт меню во всех инстансах (роут '/' всегда есть:
  // useIndexRoute инстанса или дефолтный WelcomePage). Вес блока в меню
  // считается от navigationOrder МОДУЛЯ, поэтому пункт регистрируется отдельным
  // хендлом 'home' (order 0 → выше всех), а не от core — иначе наверх уехали бы
  // и «Системные опции»/«Монитор» (у core дефолтный вес, его пункты внизу).
  const home = app.useModule('home', { navigationOrder: 0 });
  home.useNavigation([
    {
      icon: IconHome,
      label: 'Главная',
      url: '/',
    },
  ]);

  const core = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  core.useNavigation([
    {
      icon: IconSettings,
      label: 'Системные опции',
      url: '/core/options',
      component: lazy(() => import('./components/OptionsList')),
    },
    {
      icon: IconActivity,
      label: 'Системный монитор',
      url: '/core/monitor',
      component: lazy(() =>
        import('./components/SystemMonitor/SystemMonitorDashboard').then(m => ({
          default: m.SystemMonitorDashboard,
        }))
      ),
    },
  ]);
}
